<div class="overlay" (click)="emitClick()"></div>